"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onLogin;

function onLogin(auth) {
  var profile = auth.getProfile();

  if (profile && profile.roles && profile.roles.indexOf('ROLE_ADMIN') < 0) {
    throw new Error('Insufficient role');
  }
}